<template>
<div class="common-framework-container">
  <div class="wrap-top" :style="style">
    <div class="header">
      <div class="icon-logo">
        <img src="../../../assets/logo.png" alt="" @click="jumpTolink('home')">
        <!-- <img src="../../../assets/images/leyou/leyou_pic.jpg" alt="" @click="jumpTolink('home')"> -->
        <span class="title">{{this.name}}</span>
      </div>
      <div class="link-workbench" v-if="hasRightBtn">
          <a @click="toWorkbench"><i></i></a>
      </div>
    </div>
  </div>
  <div class="content">
    <div class='content-inner'><slot></slot></div>
  </div>
  <div class="footer">
    <pop-footer/>
  </div>
</div>

</template>
<script>
import {jump, util} from '@utils'
import PopFooter from "../footBar/index"
import { mapState } from 'vuex'

export default {
  name: 'common-framework',
  components: {PopFooter},
  props: {
    name: String,
    hasRightBtn:Boolean
  },
  data () {
    return {
      style: {}
    }
  },
  computed:{
    ...mapState(['userInfo']),
  },
  methods: {
    jumpTolink (name) {
      if (util.isNc(this.userInfo) && name === 'home') {
        util.jumptoNcHomepage()
      } else {
        this.$router.push({
            name
        })
      }
    },
    toWorkbench(){
      if (util.isNc(this.userInfo)) {
        util.jumptoNcPlatform()
      } else {
        jump.workbench()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  $wrap_frame_width: 1100px;
  .common-framework-container {
    background: #fff;
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 30px);
    .wrap-top {
      width: $wrap_frame_width;
      margin: 0 auto;
      height: 80px;
      background-color: #fff;

      .header {
        font-family: MicrosoftYaHei;
        // border-bottom: 1px solid #f0f0f0;
        padding-bottom: 16px;
        padding-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        .icon-logo{
          display: flex;
          align-items: center;
        }
        img {
          width: 144px;
          height: 48px;
          margin-right: 10px;
          cursor: pointer;
        }
        .title {
          font-size: 20px;
          color: #333333;
          line-height: 1;
          margin-top:12px;
          // display: inline-block;
          // vertical-align: bottom;
        }
        .link-workbench {
          margin-bottom: -5px;
          i {
            display: inline-block;
            width: 140px;
            height: 20px;
            background: url('~@assets/images/back_workbench.png') no-repeat right bottom;
            background-size: 120px auto;
          }
        }
      }
    }
    .content {
      background-color: #f7f7f7;
      // min-height: calc(100vh - 200px);
      padding-top: 15px;
      flex:1;
      display: flex;
      flex-direction: column;

      .content-inner{
        width: $wrap_frame_width;
        margin: 0 auto;
        background-color: #fff;
        flex:1;
        display: flex;
      }
    }
    .footer {
      background: #f6f6f6;
      padding: 0;
      height: 120px;
      .label-items {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #666666;
        letter-spacing: 0;
        text-align: center;
      }
    }
  }
</style>
